import React from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'

import fotoDavid from '../../../assets/imgs/foto-david.png'
import fotoFero from '../../../assets/imgs/foto-fero.png'
import fotoMarek from '../../../assets/imgs/foto-marek.png'
import fotoMartin from '../../../assets/imgs/foto-martin.png'
import fotoMates from '../../../assets/imgs/foto-mates.png'
import fotoMiso from '../../../assets/imgs/foto-miso.png'
import fotoPeter from '../../../assets/imgs/foto-peter.png'
import fotoRiso from '../../../assets/imgs/foto-riso.png'
import logo from '../../../assets/imgs/logo-power-players.png'
import styles from './team.module.scss'

const teamMembers = [
  {
    key: 1,
    name: 'Ing. Marek Loderer',
    role: 'vedúci projektu',
    imageUrl: fotoMarek,
  },
  {
    key: 2,
    name: 'Bc. Dávid Pavelka',
    role: 'Manažér vývoja',
    imageUrl: fotoDavid,
  },
  {
    key: 3,
    name: 'Bc. Martin Činčurák',
    role: 'Manažér verziovania',
    imageUrl: fotoMartin,
  },
  {
    key: 4,
    name: 'Bc. František Ďurana',
    role: 'Manažér dokumentácie',
    imageUrl: fotoFero,
  },
  {
    key: 5,
    name: 'Bc. Richard Mocák',
    role: 'Technický líder',
    imageUrl: fotoRiso,
  },
  {
    key: 6,
    name: 'Bc. Michal Ostrodický',
    role: 'Manažér komunikácie',
    imageUrl: fotoMiso,
  },
  {
    key: 7,
    name: 'Bc. Peter Pavlík',
    role: 'Manažér testovania',
    imageUrl: fotoPeter,
  },
  {
    key: 8,
    name: 'Bc. Matej Procházka',
    role: 'SCRUM master',
    imageUrl: fotoMates,
  },
]
const TeamSection = () => (
  <div id="team" className="section light">
    <Container>
      <Row>
        <Col>
          <h2>Náš tím</h2>
        </Col>
      </Row>
      <Row>
        <Col className="centered-column">
          <div className={styles.logoWrapper}>
            <img className={styles.logo} src={logo} alt="Logo power players" />
          </div>
        </Col>
      </Row>
      <Row>
        {teamMembers.map(item => (
          <Col key={item.key} xs="12" sm="6" md="3" className={styles.section}>
            <Card>
              <CardBody className={styles.avatarWrapper}>
                <img src={item.imageUrl} alt={item.name} />
                <span className={styles.title}>{item.name}</span>
                <span className={styles.secondary}>{item.role}</span>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  </div>
)

export default TeamSection
